var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-array-input',{attrs:{"required":"","label":"キャラクター属性(,区切り)","name":"characterAttributeTypes","placeholder":"例: HP,MP,SP","value":_vm.value},on:{"input":function($event){_vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }